import { useEffect, useState } from 'react'

export const useOS = () => {
  const [os, setOS] = useState('windows')

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    const platform = window.navigator.platform.toLowerCase()

    if (platform.includes('mac') || userAgent.includes('mac')) {
      setOS('mac')
    } else if (platform.includes('win') || userAgent.includes('win')) {
      setOS('windows')
    } else if (platform.includes('linux') || userAgent.includes('linux')) {
      setOS('linux')
    } else {
      setOS('windows') // default
    }
  }, [])

  return os
}
